export * from './actions/context'

import '@operato/context/ox-title-bar.js'
import '@operato/context/ox-page-title-bar.js'
import '@operato/context/ox-page-action-context-bar.js'
import '@operato/context/ox-context-toolbar.js'

import { html } from 'lit-html'

import { store, clientSettingStore } from '@operato/shell'
import { appendViewpart, TOOL_POSITION, VIEWPART_POSITION } from '@operato/layout'
import { isMobileDevice } from '@operato/utils'

import {
  APPEND_APP_TOOL,
  APPEND_PAGE_TOOL,
  REMOVE_APP_TOOL,
  REMOVE_PAGE_TOOL
} from '@things-factory/apptool-base/client'
import { APPEND_CONTEXT_TOOL } from './actions/context.js'

export async function setupContextUIPart({
  titlebar = 'header',
  contextToolbar = 'page-footer'
}: {
  titlebar?: 'header' | 'page-header'
  contextToolbar?: 'footer' | 'page-header' | 'page-footer'
}) {
  if (!isMobileDevice()) {
    const show = ((await clientSettingStore.get('title-on-page-header'))?.value || {}).show
    if (show) {
      titlebar = 'page-header'
    }
  }

  if (titlebar) {
    if (titlebar == 'page-header') {
      store.dispatch({
        type: REMOVE_APP_TOOL,
        name: 'title-bar'
      })

      store.dispatch({
        type: APPEND_PAGE_TOOL,
        tool: {
          name: 'title-bar',
          template: html` <ox-page-title-bar></ox-page-title-bar> `,
          position: TOOL_POSITION.CENTER
        }
      })
    } else {
      store.dispatch({
        type: REMOVE_PAGE_TOOL,
        name: 'title-bar'
      })

      /* add title app-tool */
      store.dispatch({
        type: APPEND_APP_TOOL,
        tool: {
          name: 'title-bar',
          template: html` <ox-title-bar></ox-title-bar> `,
          position: TOOL_POSITION.CENTER
        }
      })
    }
  }

  /*
   * footerbar 에 append 하는 순서가 중요하다.
   * footerbar는 아래에서 위로 올라가는 stack 형태의 순서이므로,
   * context-toolbar가 먼저, 그리고 context-toolbar-overlay 가 나중에 올라간다.
   */
  if (contextToolbar) {
    const position =
      contextToolbar == 'footer'
        ? VIEWPART_POSITION.FOOTERBAR
        : contextToolbar == 'page-header'
          ? VIEWPART_POSITION.PAGE_HEADERBAR
          : VIEWPART_POSITION.PAGE_FOOTERBAR

    appendViewpart({
      name: 'context-toolbar',
      viewpart: {
        show: true,
        template: html` <ox-context-toolbar></ox-context-toolbar> `
      },
      position
    })

    appendViewpart({
      name: 'context-toolbar-overlay',
      viewpart: {
        show: false,
        hovering: 'next',
        backdrop: true,
        template: html``
      },
      position
    })

    store.dispatch({
      type: APPEND_CONTEXT_TOOL,
      tool: {
        template: html` <ox-page-action-context-bar></ox-page-action-context-bar> `,
        position: TOOL_POSITION.CENTER,
        context: 'actions'
      }
    })
  }
}
